export function getCardsData(type, path) {
  // if(process.env.NODE_ENV === 'development') {
  //   return import('../apps/Cards/mock/cardsData').then((module) => {
  //     return module.mockData(type);
  //   });
  // }


  return fetch(path, {
    method: 'GET'
  })
    .then((res) => {
      if(!res.ok) {
        throw Error('Response error');
      }
      return res.json();
    });
}
